import React from "react";

import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import IconButton from "@mui/material/IconButton";
import { Tooltip } from "@mui/material";
import { GridColumns } from "@mui/x-data-grid";
import DownloadCSVModalTopo from "./DownloadCSVModalTopo";
import DownloadCSVModalDetalhe from "./DownloadCSVModalDetalhe";

export default function DownloadCSVModal(props: DownloadCSVModalPropsTypes) {
  return (
    <>
      <div
        className="containerForecastModal"
        style={{ width: "50vw", height: "90vh" }}
      >
        <div className="containerTitleModal">
          <DownloadCSVModalTopo name={props.name} />
        </div>
        <div className="containerToolbarModal">
          <Tooltip title="Sair do Modal">
            <IconButton onClick={props.handleClose}>
              <ExitToAppIcon />
            </IconButton>
          </Tooltip>
        </div>
        <div className="insiderContainerModal">
          <DownloadCSVModalDetalhe
            rows={props.rows}
            columns={props.columns}
            handleClose={props.handleClose}
            name={props.name}
          />
        </div>
      </div>
    </>
  );
}

interface DownloadCSVModalPropsTypes {
  handleClose: any;
  rows: any[];
  columns: GridColumns;
  name: string;
}
